
























import Vue from 'vue'

export default Vue.extend({
    props: {
        isSave: {
            type: Boolean,
            default: false
        }
    },
	data() {
		return {
            error: '',
            saved: this.isSave,
            saving: false,
            disabled: false
		}
	},
    watch: {
        isSave() {
            this.saved = this.isSave
            if (this.saved) {
                this.save()
            }
        }
    },
	methods: {
        save() {
            this.saved = true
            this.saving = false
            this.disabled = false
        },
        saveStart() {
            this.disabled = true
            this.saved = false
            this.saving = true
            this.$emit('save')
        }
	}
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/SaveBar.vue